module.exports = __webpack_public_path__ + "img/EtiquetaFase1.869c7039.png";